import React from 'react';
import { date } from '../../utils';
import { DEFAULT_MIN_DATE } from './consts';
import { useGridState, SelectorCell, Selector } from './selector';
import styles from './styles.module.css';
const COLUMNS = 3;
function useYearsSelectState({ value, minDate = DEFAULT_MIN_DATE, onSelect }) {
    const minYear = minDate.year;
    const maxYear = date.parseAbsoluteToLocal(new Date().toISOString()).year + 20;
    return useGridState({
        minValue: minYear,
        maxValue: maxYear,
        columns: COLUMNS,
        value,
        onSelect,
    });
}
export function YearsSelect(props) {
    const state = useYearsSelectState(props);
    return (React.createElement(Selector, { ...props, columns: COLUMNS, state: state, renderValue: value => (React.createElement(SelectorCell, { className: styles.yearsButton, value: value }, value)) }));
}
